import React from 'react';
import Schema from '../../Schema/Schema';

const FAQSchema = (props: { schema: any }) => {
	const { schema } = props;
	return (
		<Schema
			schema={{
				'@context': 'http://schema.org/',
				'@type': 'FAQPage',
				...schema,
			}}
		/>
	);
};

export default FAQSchema;
